/** Display helpers for ApiKeysSection, ported from legacy
 * includes/company_details.html's script. */

/** Legacy _formatUtc: a UTC ISO timestamp in the browser's local time as
 * YYYY-MM-DD HH:MM, or "Never". */
export function formatLocal(iso: string | null): string {
  if (!iso) return 'Never'
  const d = new Date(iso)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/** Legacy _graceCountdown: time left until the grace period ends, e.g.
 * ": 6 days 23 hours (167 hours)" - empty once it has ended. */
export function graceCountdown(iso: string | null, now: Date = new Date()): string {
  if (!iso) return ''
  const totalSecs = (new Date(iso).getTime() - now.getTime()) / 1000
  if (totalSecs <= 0) return ''
  const totalHours = Math.floor(totalSecs / 3600)
  const days = Math.floor(totalHours / 24)
  const hours = totalHours % 24
  if (days > 0 && hours > 0) return `: ${days} days ${hours} hours (${totalHours} hours)`
  if (days > 0) return `: ${days} days (${totalHours} hours)`
  return `: ${totalHours} hours`
}
